import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import * as complianceActions from '../actions/static-data-compliance.actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const staticDataComplianceStatusesFeatureKey = 'staticDataComplianceStatuses';

export interface StaticDataComplianceStatusesState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: StaticDataComplianceStatusesState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(complianceActions.loadComplianceStatuses, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.loadComplianceStatusesSuccess, (state, { response }) => ({ ...state, loading: false, data: response, error: null })),
  on(complianceActions.loadComplianceStatusesFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getComplianceStatuses = (state: StaticDataComplianceStatusesState) => state.data;
export const getComplianceStatusesLoading = (state: StaticDataComplianceStatusesState) => state.loading;
export const getComplianceStatusesError = (state: StaticDataComplianceStatusesState) => state.error;